import firebase from 'firebase/compat/app'
import 'firebase/compat/auth'
import 'firebase/compat/firestore'
import 'firebase/compat/storage'

export var firebaseConfig = {
    apiKey: process.env.VUE_APP_ADP_APIKEY,
    authDomain: process.env.VUE_APP_ADP_AUTHDOMAIN,
    databaseURL: process.env.VUE_APP_ADP_DATABASEURL,
    projectId: process.env.VUE_APP_ADP_PROJECTID,
    storageBucket: process.env.VUE_APP_ADP_STORAGEBUCKET,
    messagingSenderId: process.env.VUE_APP_ADP_MESSAGINGSENDERID,
    appId: process.env.VUE_APP_ADP_APPID,
    measurementId: process.env.VUE_APP_ADP_MEASUREMENTID
};

if (!firebase.apps.length) {
    firebase.initializeApp(firebaseConfig);
}

export const auth = firebase.auth();
export const db = firebase.firestore();
export const storage = firebase.storage();

export default firebase;
